import { Image } from 'expo-image';
import { Link } from 'expo-router';
import { Pressable, StyleSheet } from 'react-native';

import { useClickLogs } from '@fhs-legacy/frontend/src/hooks/use-click-logs';

export function MontrealSmokedMeatCard({ pickUpHref }: { pickUpHref: string }) {
  const { logMontrealSmokedMeatCardClickEvent } = useClickLogs();
  return (
    <Link href={pickUpHref} asChild>
      <Pressable onPress={logMontrealSmokedMeatCardClickEvent}>
        <Image
          alt="Montreal Smoked Meat. Stacked to the max. Order now!"
          source={require('./montreal-smoked-meat-card.webp')}
          placeholder={{ thumbhash: 'HUkKFgQJWUZYaJiYhoh4dEiHVpCFCEs' }}
          style={[styles.banner]}
        />
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  banner: {
    aspectRatio: 750 / 840,
  },
});
